import Phaser from "phaser";

type ImageAsset = {
  key: string;
  image: string;
  type: "image";
};

type AtlasAsset = {
  key: string;
  image: string;
  data: string;
  type: "atlas";
};

type AssetManifest = {
  required: Array<ImageAsset | AtlasAsset>;
};

export class PreloadScene extends Phaser.Scene {
  constructor() {
    super("PreloadScene");
  }

  preload(): void {
    const width = this.scale.width;
    const height = this.scale.height;

    const frame = this.add.rectangle(width / 2, height / 2, 720, 24, 0x080b10)
      .setStrokeStyle(1, 0x8a6d40);
    const bar = this.add.rectangle(width / 2 - 356, height / 2, 0, 16, 0x7e34b8)
      .setOrigin(0, 0.5);
    const status = this.add.text(width / 2, height / 2 + 52, "WERYFIKACJA ASSETÓW…", {
      fontFamily: "Georgia",
      fontSize: "20px",
      color: "#d8c49a",
    }).setOrigin(0.5);

    this.load.on("progress", (value: number) => {
      bar.width = 712 * value;
    });

    this.load.json("asset-manifest", "assets/asset-manifest.json");

    this.load.once("complete", () => {
      const manifest = this.cache.json.get("asset-manifest") as AssetManifest | undefined;
      if (!manifest) {
        status.setText("BŁĄD: brak manifestu assetów");
        return;
      }

      for (const asset of manifest.required) {
        if (asset.type === "image") {
          this.load.image(asset.key, asset.image);
        } else {
          this.load.atlas(asset.key, asset.image, asset.data);
        }
      }

      this.load.once("complete", () => {
        frame.destroy();
        bar.destroy();
        status.destroy();
        this.scene.start("TitleScene");
      });

      this.load.once("loaderror", (file: Phaser.Loader.File) => {
        status.setText(`BŁĄD ASSETU: ${file.key}`);
      });

      this.load.start();
    });
  }
}
